const SITE = "Tassie Automotive";

const META = {
  "/": {
    title: `${SITE} — Repco Authorised Mechanic Glenorchy, Hobart TAS`,
    description:
      "Repco Authorised mechanical workshop in Glenorchy, Hobart. Car servicing, brakes, diagnostics, tyres & repairs. Book online in 60 seconds. Call (03) 6288 7861.",
  },
  "/services": {
    title: `Car Servicing & Repairs — ${SITE} Glenorchy`,
    description:
      "Full range of mechanical services in Glenorchy: logbook servicing, brakes, suspension, electrical diagnostics, tyres and more. Upfront pricing, book online.",
  },
  "/book": {
    title: `Book a Service Online — ${SITE} Glenorchy`,
    description:
      "Book your car service online in 60 seconds — pick a service, choose a time, done. No account needed. Tassie Automotive, 46 Grove Rd Glenorchy TAS.",
  },
  "/about": {
    title: `About Our Workshop — ${SITE} Glenorchy`,
    description:
      "Meet Tassie Automotive — Glenorchy's trusted Repco Authorised workshop. Real photos, honest pricing and professional care for modern and classic vehicles.",
  },
  "/contact": {
    title: `Contact Us — ${SITE} Glenorchy | (03) 6288 7861`,
    description:
      "Get in touch with Tassie Automotive: 46 Grove Rd, Glenorchy TAS 7010. Call (03) 6288 7861 or send a message — we reply fast.",
  },
  "/cars-for-sale": {
    title: `Used Cars for Sale Hobart — ${SITE} Glenorchy`,
    description:
      "Quality used cars for sale in Glenorchy, Hobart — workshop-checked, honestly described. Browse current stock from Tassie Automotive.",
  },
  "/cars-for-rent": {
    title: `Car Rentals Hobart — ${SITE} Glenorchy`,
    description:
      "Affordable car rentals in Glenorchy, Hobart from a trusted local workshop. Flexible terms, well-maintained vehicles. Enquire online.",
  },
  "/login": {
    title: `Workshop Staff Login — ${SITE}`,
    description:
      "Secure staff sign-in for the Tassie Automotive workshop dashboard. Manage bookings, services and customer messages. Staff access only.",
  },
  "/register": {
    title: `Create Staff Account — ${SITE}`,
    description:
      "Account registration for Tassie Automotive workshop staff. Customers can book a service online without an account in under 60 seconds.",
  },
  "/account": {
    title: `My Garage — ${SITE} Customer Account`,
    description:
      "Your Tassie Automotive garage: track your next service due date, saved vehicles, booking history and digital logbook — all in one place.",
  },
  "/account/login": {
    title: `Customer Login — ${SITE} Glenorchy`,
    description:
      "Sign in or create a free Tassie Automotive account to track your vehicle's service history, next service reminders and one-tap rebooking.",
  },
  "/dashboard": {
    title: `Dashboard — ${SITE}`,
    description:
      "Tassie Automotive customer dashboard — view your bookings and service updates from our Glenorchy workshop.",
  },
};

const SERVICE_PAGE_META = {
  "brake-repair": {
    title: `Brake Repair Glenorchy — ${SITE} | From $120`,
    description:
      "Brake repair in Glenorchy: pads, rotors, machining, calipers & fluid flush from $120. Repco Authorised, same-day jobs, written quotes. Book online or call (03) 6288 7861.",
  },
  "logbook-servicing": {
    title: `Logbook Servicing Glenorchy — ${SITE} | Warranty Safe`,
    description:
      "Logbook servicing in Glenorchy from $199 — manufacturer schedule, quality parts, logbook stamped, new-car warranty protected. Repco Authorised. Book online in 60 seconds.",
  },
  "car-diagnostics": {
    title: `Car Diagnostics Glenorchy — ${SITE} | Check Engine Light`,
    description:
      "Check engine light on? Full computer diagnostics in Glenorchy from $89 — engine, ABS, airbag & transmission scans with a plain-English report and written repair quote.",
  },
  "tyres-wheel-alignment": {
    title: `Tyres & Wheel Alignment Glenorchy — ${SITE}`,
    description:
      "New tyres, balancing, punctures and laser wheel alignment in Glenorchy. $65 fitting labour per tyre — you pick the brand and budget. Book online at Tassie Automotive.",
  },
  "air-conditioning": {
    title: `Car Aircon Regas & Repair Glenorchy — ${SITE}`,
    description:
      "Car air conditioning service in Glenorchy from $149 — regas, leak detection, compressor repairs and antibacterial treatment for all makes. Book before summer.",
  },
  "roadworthy-certificate": {
    title: `Roadworthy Certificate Glenorchy — ${SITE} | $110`,
    description:
      "Vehicle safety inspections in Glenorchy — $110, same-week bookings. Honest checks, written repair lists and repairs + re-check under one roof at Tassie Automotive.",
  },
};

export function applySeo(pathname) {
  let meta = META[pathname];
  if (!meta && pathname.startsWith("/services/")) {
    const slug = pathname.split("/")[2] || "";
    meta = SERVICE_PAGE_META[slug];
  }
  if (!meta && pathname.startsWith("/vehicles/")) {
    meta = {
      title: `Vehicle Details — ${SITE} Glenorchy`,
      description: "View photos, specs and pricing for this vehicle at Tassie Automotive, Glenorchy TAS.",
    };
  }
  if (!meta && pathname.startsWith("/mechanic/")) {
    const suburb = pathname.split("/")[2] || "";
    const nice = suburb.split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
    meta = {
      title: `Mechanic near ${nice} — ${SITE} Glenorchy`,
      description: `Looking for a mechanic near ${nice}? Tassie Automotive is minutes away at 46 Grove Rd Glenorchy — Repco Authorised logbook servicing, brakes, diagnostics & tyres. Book online.`,
    };
  }
  if (!meta && pathname.startsWith("/booking/manage/")) {
    meta = {
      title: `Manage Your Booking — ${SITE} Glenorchy`,
      description:
        "View, reschedule or cancel your Tassie Automotive booking online — no account or phone call needed. Changes are confirmed instantly.",
    };
  }
  if (!meta && pathname.startsWith("/c/")) {
    meta = {
      title: `Booking Confirmed — ${SITE} Glenorchy`,
      description:
        "Thanks for confirming your booking with Tassie Automotive, Glenorchy. We'll see you and your car at 46 Grove Rd at your chosen time.",
    };
  }
  if (!meta) {
    meta = {
      title: `${SITE} — Mechanic Glenorchy, Hobart TAS`,
      description:
        "Tassie Automotive — Glenorchy's Repco Authorised workshop for servicing, repairs, diagnostics, tyres, used car sales and rentals. 46 Grove Rd, Glenorchy TAS.",
    };
  }
  document.title = meta.title;
  const tag = document.querySelector('meta[name="description"]');
  if (tag) tag.setAttribute("content", meta.description);
  let canon = document.querySelector('link[rel="canonical"]');
  if (!canon) {
    canon = document.createElement("link");
    canon.setAttribute("rel", "canonical");
    document.head.appendChild(canon);
  }
  canon.setAttribute("href", `https://tassieautomotive.com.au${pathname === "/" ? "/" : pathname}`);
  return meta;
}
